import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Tooltip, Legend } from 'chart.js';
import dayjs from 'dayjs';
import React from 'react';
import { Bar } from 'react-chartjs-2';
import classes from '../../Finances.module.scss';
import { NUM_LOCALE } from '@/utils/constants';
import { formatNumberWithSuffix, getCurrencySymbol, getIntegrationName, vendorsColors } from '@/utils/helpers';
ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend);
const StackedBar = ({ integrationDailyStatements, dateInfo, currency }) => {
    const weekDates = Array.from({ length: 7 }, (_, i) => dayjs(dateInfo === null || dateInfo === void 0 ? void 0 : dateInfo.date).startOf('isoWeek').add(i, 'day').format('YYYY-MM-DD'));
    const weekDatesLabels = weekDates === null || weekDates === void 0 ? void 0 : weekDates.map((day) => dayjs(day).format('DD/MM'));
    const dailyIntegrationByVendor = integrationDailyStatements === null || integrationDailyStatements === void 0 ? void 0 : integrationDailyStatements.reduce((vendors, { vendor, totalIncome, date }) => {
        if (!vendors[vendor]) {
            vendors[vendor] = [];
        }
        vendors[vendor].push({ date, totalIncome });
        return vendors;
    }, {});
    const datasets = Object
        .entries(dailyIntegrationByVendor)
        .map(([key, value]) => ({ vendor: key, value }))
        .map((vendor) => {
        const dataDays = weekDates === null || weekDates === void 0 ? void 0 : weekDates.map((day) => {
            var _a, _b;
            const getDay = (_a = vendor === null || vendor === void 0 ? void 0 : vendor.value) === null || _a === void 0 ? void 0 : _a.find((item) => item.date === day);
            return (_b = getDay === null || getDay === void 0 ? void 0 : getDay.totalIncome) !== null && _b !== void 0 ? _b : 0;
        });
        return {
            label: getIntegrationName(vendor === null || vendor === void 0 ? void 0 : vendor.vendor),
            data: dataDays,
            backgroundColor: vendorsColors(vendor === null || vendor === void 0 ? void 0 : vendor.vendor)
        };
    });
    const data = {
        labels: weekDatesLabels,
        datasets
    };
    const options = {
        plugins: {
            tooltip: {
                mode: 'index',
                intersect: false,
                backgroundColor: '#fff',
                borderColor: '#eee',
                borderWidth: 1,
                cornerRadius: 4,
                padding: 12,
                titleColor: '#a7a7a7',
                titleMarginBottom: 10,
                bodySpacing: 10,
                titleFont: {
                    size: 14,
                    weight: 400,
                    family: 'Inter'
                },
                bodyColor: '#171717',
                bodyFont: {
                    size: 12,
                    weight: 500,
                    family: 'Inter'
                },
                callbacks: {
                    title: (items) => {
                        const dataIndex = items[0].dataIndex;
                        return dayjs(weekDates[dataIndex]).format('DD/MM/YYYY');
                    },
                    label: function (context) {
                        var _a, _b;
                        let label = (_a = context.dataset.label) !== null && _a !== void 0 ? _a : '';
                        const value = `${currency ? getCurrencySymbol(currency !== null && currency !== void 0 ? currency : '') : ''} ${(_b = context.parsed.y) === null || _b === void 0 ? void 0 : _b.toLocaleString(NUM_LOCALE, { minimumFractionDigits: 2 })}`;
                        if (context.parsed.y !== null) {
                            label = `${label} ${value}`;
                        }
                        return label;
                    },
                    labelColor: (tooltipItem) => {
                        var _a;
                        const vendorKey = String((_a = tooltipItem.dataset.backgroundColor) !== null && _a !== void 0 ? _a : '');
                        return {
                            borderColor: 'transparent',
                            borderRadius: 2,
                            backgroundColor: vendorKey
                        };
                    }
                }
            },
            legend: {
                position: 'bottom',
                labels: {
                    boxWidth: 10,
                    boxHeight: 10,
                    useBorderRadius: true,
                    borderRadius: 2,
                    color: '#a7a7a7',
                    font: {
                        size: 12
                    }
                }
            }
        },
        elements: {
            bar: {
                borderRadius: 2
            }
        },
        responsive: true,
        maintainAspectRatio: false,
        scales: {
            x: {
                stacked: true,
                grid: {
                    color: '#fff'
                },
                border: {
                    color: '#F6F6F6'
                },
                ticks: {
                    color: '#474747',
                    font: {
                        size: 10,
                        weight: 600,
                        family: 'Inter'
                    }
                }
            },
            y: {
                stacked: true,
                beginAtZero: true,
                border: {
                    color: '#fff'
                },
                grid: {
                    tickColor: '#fff',
                    color: '#F6F6F6'
                },
                ticks: {
                    crossAlign: 'far',
                    color: '#474747',
                    font: {
                        size: 10,
                        weight: 600,
                        family: 'Inter'
                    },
                    callback: (value) => {
                        return typeof value === 'number' ? `${currency ? getCurrencySymbol(currency !== null && currency !== void 0 ? currency : '') : ''} ${formatNumberWithSuffix(value)}` : '';
                    }
                }
            }
        }
    };
    return (React.createElement("div", { className: classes.diagramHolder },
        React.createElement(Bar, { options: options, data: data, height: 210 })));
};
export default StackedBar;
